module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topWrapper"
  }, [_c('top-box', {
    staticClass: "total",
    attrs: {
      "text": "전체",
      "data": _vm.topData.total
    }
  }), _c('top-box', {
    staticClass: "doing",
    attrs: {
      "text": "진행",
      "data": _vm.topData.cnt_2
    }
  }), _c('top-box', {
    staticClass: "hold",
    attrs: {
      "text": "홀딩",
      "data": _vm.topData.cnt_3
    }
  }), _c('top-box', {
    staticClass: "complete",
    attrs: {
      "text": "완료",
      "data": _vm.topData.cnt_4
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-236e4b2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/Dashboard.vue
// module id = 834
// module chunks = 1